<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      // requestType: 'GET',
    };
  },
  mounted() {
    this.getConfigList('reverse_reward_branch_office_report_list');
  },
  methods: {
  },
};
</script>
